import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import 'hammerjs';
import { LoginPanelComponent } from './login.panelComponent';

import { enableProdMode } from '@angular/core';
enableProdMode();

@NgModule({
    imports: [BrowserModule, FormsModule, MaterialModule, FlexLayoutModule, BrowserAnimationsModule, HttpModule],
    declarations: [LoginPanelComponent],
    bootstrap: [LoginPanelComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./app/login.module.ts